module.exports = __webpack_public_path__ + "img/vernazzaheritage_background_hero.8c688a00.png";